"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            marginBottom: theme.spacing(1),
        },
        progress: {
            transition: theme.transitions.create('width', {
                duration: 1000,
                easing: 'linear',
            }),
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            backgroundColor: '#E0E8F9',
            zIndex: 1,
        },
        icon: {
            zIndex: 2,
        },
        focus: {
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            padding: theme.spacing(1.5, 0, 1.5, 1),
        },
        break: {
            display: 'flex',
            position: 'relative',
            borderLeft: "1px solid #E0E0E0",
            padding: theme.spacing(1.5, 0, 1.5, 1),
        },
        label: {
            lineHeight: 1,
            paddingLeft: theme.spacing(1),
            zIndex: 2,
        },
    });
});
var PomodoroCycle = function (_a) {
    var breakTime = _a.breakTime, focusTime = _a.focusTime, mode = _a.mode, _b = _a.modeProgress, modeProgress = _b === void 0 ? 0 : _b, status = _a.status;
    var minWidth = 90;
    var classes = useStyles();
    var totalTime = focusTime + breakTime || 1;
    var focusPercentage = (focusTime / totalTime) * 100;
    var breakPercentage = (breakTime / totalTime) * 100;
    var focusProgress = status === 'completed' ? 100 : 0;
    var breakProgress = status === 'completed' ? 100 : 0;
    if (mode === 'focus') {
        focusProgress = modeProgress;
    }
    else if (mode === 'break' && status === 'active') {
        breakProgress = modeProgress;
        focusProgress = 100;
    }
    return (react_1.default.createElement(core_1.Paper, { className: classes.root },
        react_1.default.createElement("div", { className: classes.focus, style: { width: focusPercentage + "%", minWidth: minWidth } },
            !!focusProgress && (react_1.default.createElement("div", { className: classes.progress, style: { width: focusProgress + "%" } })),
            status === 'planned' && (react_1.default.createElement(icons_1.RadioButtonUncheckedRounded, { color: "disabled", className: classes.icon })),
            status === 'active' && (react_1.default.createElement(icons_1.PlayCircleOutlineRounded, { color: "primary", className: classes.icon })),
            status === 'completed' && (react_1.default.createElement(icons_1.CheckCircleOutlineRounded, { color: "primary", className: classes.icon })),
            react_1.default.createElement(core_1.Typography, { className: classes.label },
                "Focus",
                ' ',
                react_1.default.createElement(core_1.Typography, { component: "span", color: "textSecondary" }, focusTime / 60))),
        react_1.default.createElement("div", { className: classes.break, style: { width: breakPercentage + "%", minWidth: minWidth } },
            !!breakProgress && (react_1.default.createElement("div", { className: classes.progress, style: { width: breakProgress + "%" } })),
            react_1.default.createElement(core_1.Typography, { className: classes.label },
                "Break",
                ' ',
                react_1.default.createElement(core_1.Typography, { component: "span", color: "textSecondary" }, breakTime / 60)))));
};
exports.default = PomodoroCycle;
//# sourceMappingURL=PomodoroCycle.js.map